/*
  Fix: product gallery thumbnail clicks are sometimes ignored.

  The theme's <xo-carousel-thumbnail> treats ANY pointer movement between press and
  release (even 1px) as a drag and sets `isThumbMoving` on its <xo-carousel-list>.
  The thumbnail click handler then skips navigation (xo-webcomponents.js, CarouselSlide
  handleClick). This listener runs first (capture phase) and clears that flag when the
  pointer moved less than THRESHOLD px, so small mouse/trackpad jitter or a slightly
  sliding tap still counts as a click. Real drags (>= THRESHOLD px) behave as before.
*/
(() => {
  const THRESHOLD = 6;
  let start = null;

  const point = (event) => (event.changedTouches && event.changedTouches[0]) || event;

  const onStart = (event) => {
    if (!event.target.closest('xo-carousel-thumbnail')) {
      start = null;
      return;
    }
    const { clientX, clientY } = point(event);
    start = { x: clientX, y: clientY };
  };

  const onEnd = (event) => {
    if (!start) return;
    const thumbnail = event.target.closest('xo-carousel-thumbnail');
    if (!thumbnail) return;
    const { clientX, clientY } = point(event);
    if (Math.hypot(clientX - start.x, clientY - start.y) < THRESHOLD) {
      const list = thumbnail.querySelector('xo-carousel-list');
      if (list) list.isThumbMoving = false;
    }
  };

  document.addEventListener('mousedown', onStart, true);
  document.addEventListener('touchstart', onStart, { capture: true, passive: true });
  document.addEventListener('click', onEnd, true);
  document.addEventListener('touchend', onEnd, { capture: true, passive: true });
})();
